<template>
  <div>
    <div class="container-fluid m-0 p-0">
      <div class="bgFotoMain" />
      <!-- Überschrift und Text -->
      <div class="row justify-content-center">
        <div class="col-xs-12 col-sm-12 col-md-10 col-lg-7 center">
          <h3 class="willkommen__title">
            {{ $t("Herzlich willkommen im Hotel Weinhaus Eberitzsch") }}
          </h3>
          <p class="willkommen__text">
            {{ $t("entspanntesWochenende") }}
          </p>
        </div>
      </div>
      <!-- vieren Kacheln -->
      <div class="kachelContainer">
        <router-link to="/hotel" class="kachel-link">
          <div class="card bg1">
            <div class="card-body kachel-body">
              <h5 class="card-title">{{ $t("Hotel") }}</h5>
            </div>
          </div>
        </router-link>

        <router-link to="/restaurant" class="kachel-link">
          <div class="card bg2">
            <div class="card-body kachel-body">
              <h5 class="card-title">{{ $t("Restaurant") }}</h5>
            </div>
          </div>
        </router-link>

        <router-link to="/feiern" class="kachel-link">
          <div class="card bg3">
            <div class="card-body kachel-body">
              <h5 class="card-title">{{ $t("Feiern") }}</h5>
            </div>
          </div>
        </router-link>

        <router-link to="/motorrad" class="kachel-link">
          <div class="card bg4">
            <div class="card-body kachel-body">
              <h5 class="card-title">{{ $t("Motorrad") }}</h5>
            </div>
          </div>
        </router-link>
      </div>

      <!-- 3x3 Block  Icons-->
      <section class="py-5" style="background: #f3f3f3">
        <div class="container-fluid d-flex justify-content-center">
          <div class="container">
            <div class="row g-5 justify-content-center mx-5">
              <!-- deine col-12 col-md-6 col-lg-4 Blöcke bleiben hier -->
              <!-- Item 1 -->
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
                <div class="d-flex align-items-start gap-3">
                  <img
                    src="../assets/wlan.png"
                    alt="Freies WLAN"
                    style="width: 44px; height: 44px"
                  />
                  <div>
                    <h3 class="h4 mb-2" style="font-family: 'Yeseva', serif">
                      {{ $t("Freies WLAN") }}
                    </h3>
                    <p class="mb-0 text-muted" style="font-family: 'Hind', sans-serif">
                      {{ $t("FreiesWLANText") }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Item 2 -->
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
                <div class="d-flex align-items-start gap-3">
                  <img
                    src="../assets/parkplatz.png"
                    alt="Parkplatz"
                    style="width: 44px; height: 44px"
                  />
                  <div>
                    <h3 class="h4 mb-2" style="font-family: 'Yeseva', serif">
                      {{ $t("Parkplätze") }}
                    </h3>
                    <p class="mb-0 text-muted" style="font-family: 'Hind', sans-serif">
                      {{ $t("Ausreichend Parkplätze gibt es direkt am Haus") }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Item 3 -->
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
                <div class="d-flex align-items-start gap-3">
                  <img
                    src="../assets/behindert.png"
                    alt="Behindertenfreundlich"
                    style="width: 44px; height: 44px"
                  />
                  <div>
                    <h3 class="h4 mb-2" style="font-family: 'Yeseva', serif">
                      {{ $t("Behindertenfreundlich") }}
                    </h3>
                    <p class="mb-0 text-muted" style="font-family: 'Hind', sans-serif">
                      {{ $t("BehindertenfreundlichText") }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row g-5 justify-content-center mx-5">
              <!-- Item 4 -->
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
                <div class="d-flex align-items-start gap-3">
                  <img
                    src="../assets/standesamt.png"
                    alt="Standesamt"
                    style="width: 44px; height: 44px"
                  />
                  <div>
                    <h3 class="h4 mb-2" style="font-family: 'Yeseva', serif">
                      {{ $t("Standesamt") }}
                    </h3>
                    <p class="mb-0 text-muted" style="font-family: 'Hind', sans-serif">
                      {{ $t("StandesamtText") }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Item 5 -->
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
                <div class="d-flex align-items-start gap-3">
                  <img
                    src="../assets/biergarten.png"
                    alt="Biergarten"
                    style="width: 44px; height: 44px"
                  />
                  <div>
                    <h3 class="h4 mb-2" style="font-family: 'Yeseva', serif">
                      {{ $t("Biergarten") }}
                    </h3>
                    <p class="mb-0 text-muted" style="font-family: 'Hind', sans-serif">
                      {{ $t("BiergartenText") }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Item 6 -->
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
                <div class="d-flex align-items-start gap-3">
                  <img
                    src="../assets/solarium.png"
                    alt="Solarium"
                    style="width: 44px; height: 44px"
                  />
                  <div>
                    <h3 class="h4 mb-2" style="font-family: 'Yeseva', serif">
                      {{ $t("Solarium") }}
                    </h3>
                    <p class="mb-0 text-muted" style="font-family: 'Hind', sans-serif">
                      {{ $t("SolariumText") }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row g-5 justify-content-center mx-5">
              <!-- Item 7 -->
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
                <div class="d-flex align-items-start gap-3">
                  <img
                    src="../assets/sauna.png"
                    alt="Sauna"
                    style="width: 44px; height: 44px"
                  />
                  <div>
                    <h3 class="h4 mb-2" style="font-family: 'Yeseva', serif">
                      {{ $t("Sauna") }}
                    </h3>
                    <p class="mb-0 text-muted" style="font-family: 'Hind', sans-serif">
                      {{ $t("SaunaText") }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Item 8 -->
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
                <div class="d-flex align-items-start gap-3">
                  <img
                    src="../assets/kurpark.png"
                    alt="Kurpark"
                    style="width: 44px; height: 44px"
                  />
                  <div>
                    <h3 class="h4 mb-2" style="font-family: 'Yeseva', serif">
                      {{ $t("direkt am Kurpark") }}
                    </h3>
                    <p class="mb-0 text-muted" style="font-family: 'Hind', sans-serif">
                      {{ $t("direktamKurparkText") }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Item 9 -->
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
                <div class="d-flex align-items-start gap-3">
                  <img
                    src="../assets/tradition.png"
                    alt="Tradition"
                    style="width: 44px; height: 44px"
                  />
                  <div>
                    <h3 class="h4 mb-2" style="font-family: 'Yeseva', serif">
                      {{ $t("Tradition") }}
                    </h3>
                    <p class="mb-0 text-muted" style="font-family: 'Hind', sans-serif">
                      {{ $t("seit 1910") }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- Schwarztal -->
      <section>
        <div class="row justify-content-center">
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-7 center">
            <h3 class="willkommen__title">{{ $t("Am Tor zum Schwarzatal") }}</h3>
            <p class="willkommen__text">
              {{
                $t(
                  "Das Hotel Weinhaus Eberitzsch ist idealer Ausgangspunkt für Ausflüge ins wildromantische Schwarzatal. Genießen Sie unsere schönen Ausflugsziele in traumhafter Natur oder die vielen Sehenswürdigkeiten in der Region."
                )
              }}
            </p>
          </div>
        </div>
        <div class="row g-5 justify-content-center mx-5 mb-5">
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-7 center">
            <karussellmain1 />
          </div>
        </div>
      </section>

      <!-- angebote-->
     <section v-if="showOstern">
  <div class="row justify-content-center">
    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-7 center p-5">
      <img
        src="../assets/Ostern2026.jpg"
        alt="Angebote"
        style="width: 100%; height: auto; margin-top: 10px"
      />
    </div>
  </div>
</section>

<section v-if="showPfingsten">
  <div class="row justify-content-center">
    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-7 center p-5">
      <img
        src="../assets/pfingsten2026.jpg"
        alt="Angebote"
        style="width: 100%; height: auto; margin-top: 10px"
      />
    </div>
  </div>
</section>
      <!-- Hotel -->
      <section>
        <div class="container-fluid" style="background: #f3f3f3">
          <div class="row align-items-center justify-content-center">
            <!-- Text + Button -->
            <div class="col-lg-4 d-flex flex-column align-items-center text-center">
              <h3 class="willkommen__title2 pt-5">
                {{ $t("GemütlicheZimmer") }}
              </h3>

              <p class="willkommen__text">
                {{ $t("UnserHotelverfügtüber29ZimmerText") }}
              </p>

              <p class="buttonBackground">
                <router-link to="/hotel" class="btn-reservierung">
                  <div class="pt-3">{{ $t("Reservieren") }}</div>
                </router-link>
              </p>
            </div>

            <!-- Karussell -->
            <div class="col-lg-4 p-5">
              <karussellhotel1 />
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="container-fluid" style="background: #f3f3f3">
          <div class="row align-items-center justify-content-center">
            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-4 center p-5">
              <karussellrestaurant1 />
            </div>
            <div class="col-lg-4 d-flex flex-column align-items-center text-center">
              <p class="willkommen__title2 pt-5">{{ $t("ErstklassischesRestaurant") }}</p>
              <p class="willkommen__text">
                {{ $t("ErstklassischesRestaurantText") }}
              </p>
              <p class="buttonBackground">
                <router-link to="/restaurant" class="btn-reservierung">
                  <div class="pt-3">{{ $t("Reservieren") }}</div>
                </router-link>
              </p>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="container-fluid" style="background: #f3f3f3">
          <div class="row align-items-center justify-content-center">
            <!-- Text + Button -->
            <div class="col-lg-4 d-flex flex-column align-items-center text-center">
              <h3 class="willkommen__title2 pt-5">
                {{ $t("FeiernHochzeitenimGrünen") }}
              </h3>

              <p class="willkommen__text">
                {{ $t("FeiernHochzeitenimGrünenText") }}
              </p>

              <p class="buttonBackground">
                <router-link to="/feiern" class="btn-reservierung">
                  <div class="pt-3">{{ $t("Reservieren") }}</div>
                </router-link>
              </p>
            </div>

            <!-- Karussell -->
            <div class="col-lg-4 p-5">
              <karussellfeiern1 />
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="container-fluid" style="background: #f3f3f3">
          <div class="row align-items-center justify-content-center">
            <div class="col-lg-4 p-5">
              <karussellmotorrad1 />
            </div>
            <div class="col-lg-4 d-flex flex-column align-items-center text-center">
              <p class="willkommen__title2 pt-5">{{ $t("Motorradhotel Touren") }}</p>
              <p class="willkommen__text">
                {{ $t("MotorradhotelTourenText1") }}
                {{ $t("MotorradhotelTourenText2") }}
              </p>
              <div class="row justify-content-center">
                <div class="col-lg-5">
                  <p class="buttonBackground">
                    <router-link to="/Motorrad" class="btn-reservierung">
                      <div class="pt-3">{{ $t("Reservieren") }}</div>
                    </router-link>
                  </p>
                </div>
                <div class="col-lg-4">
                  <a
                    href="https://www.tourenfahrer-hotels.de/hotel/deutschland/thueringer-wald/hotel-weinhaus-eberitzsch/detail/"
                    target="_blank"
                    rel="noopener"
                  >
                    <img
                      src="../assets/tf-ph2.jpg"
                      alt="Motorrad"
                      style="width: 100%; height: auto; margin-top: 10px"
                  /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Gästeempfehlungen -->
      <section>
        <div class="row justify-content-center">
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-7 center">
            <h3 class="willkommen__title">{{ $t("Gästeempfehlenunsweiter") }}</h3>
            <p class="willkommen__text">
              {{ $t("GästeempfehlenunsweiterText") }}
            </p>
            <h4 class="textcenter">
              “ {{ $t("Gästeempfehlung1") }}
              ”
            </h4>
            <h6 class="textcenter">{{ $t("GästeempfehlungGast1") }}</h6>
            <h4 class="textcenter">“ {{ $t("Gästeempfehlung2") }} ”</h4>
            <h6 class="textcenter">{{ $t("GästeempfehlungGast2") }}</h6>
            <h4 class="textcenter">“ {{ $t("Gästeempfehlung3") }} ”</h4>
            <h6 class="textcenter">{{ $t("GästeempfehlungGast3") }}</h6>
          </div>
        </div>
      </section>
      <!-- Team -->
      <section>
        <div class="row justify-content-center" style="background: #f3f3f3">
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-7 center">
            <h3 class="willkommen__title">{{ $t("Unser Team") }}</h3>
            <div class="row textcenter">
              <div class="col-xs-12 col-sm-12 col-md-10 col-lg-3">
                <div class="card team">
                  <img :src="require('@/assets/team1.jpg')" class="oval" alt="Team" />
                  <div class="card-body">
                    <h4 class="card-title">{{ $t("Lars") }}</h4>
                    <p class="card-text">
                      {{ $t("Wedding Planer") }}<br />
                      {{ $t("Küchenmeister") }}<br />
                      {{ $t("Tourenfahrer") }}<br />
                      {{ $t("Ausflüge") }}<br />
                      {{ $t("Geschäftsführung") }}<br />
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-sm-12 col-md-10 col-lg-3">
                <div class="card team">
                  <img :src="require('@/assets/team2.jpg')" class="oval" alt="Team" />
                  <div class="card-body">
                    <h4 class="card-title">{{ $t("Sven") }}</h4>
                    <p class="card-text">
                      {{ $t("Rezeption") }}<br />
                      {{ $t("Restaurant") }}<br />
                      {{ $t("Ausflüge") }}<br />
                      {{ $t("Geschäftsführung") }}<br />
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-sm-12 col-md-10 col-lg-3">
                <div class="card team">
                  <img :src="require('@/assets/team3.jpg')" class="oval" alt="Team" />
                  <div class="card-body">
                    <h4 class="card-title">{{ $t("Sandra") }}</h4>
                    <p class="card-text">
                      {{ $t("Frühstück") }}<br />
                      {{ $t("Buchhaltung") }}<br />
                      {{ $t("Ausflüge") }}<br />
                      {{ $t("Konditorei") }}<br />
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-sm-12 col-md-10 col-lg-3">
                <div class="card team">
                  <img :src="require('@/assets/team4.jpg')" class="oval" alt="Team" />
                  <div class="card-body">
                    <h4 class="card-title">{{ $t("Kathrin") }}</h4>
                    <p class="card-text">
                      {{ $t("Frühstück") }}<br />
                      {{ $t("Etage") }}<br />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <stickybarTelMail />
  </div>
  <stickyPfeil />
</template>

<script>
//import carouselHeader from "../components/carouselHeader.vue";
import stickybarTelMail from "../components/stickybarTelMail.vue";
import stickyPfeil from "../components/stickyPfeil.vue";
import karussellmain1 from "../components/KarussellMain1.vue";
import karussellhotel1 from "../components/KarussellHotel1.vue";

import karussellrestaurant1 from "../components/KarussellRestaurant1.vue";
import karussellfeiern1 from "../components/KarussellFeiern1.vue";
import karussellmotorrad1 from "../components/KarussellMotorrad1.vue";

export default {
  name: "MainPage",

  data() {
    return {
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      newSite: null,
    };
  },
  components: {
    stickybarTelMail,
    stickyPfeil,
    karussellmain1,
    karussellhotel1,
    karussellrestaurant1,
    karussellfeiern1,
    karussellmotorrad1,
  },
  methods: {},
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
   showOstern() {
    const today = new Date().toISOString().slice(0, 10)

    return today <= "2026-04-06"
  },

  showPfingsten() {
    const today = new Date().toISOString().slice(0, 10)

    return today >= "2026-04-07" && today <= "2026-05-25"
  }
  },
  mounted() {
    window.onresize = () => {
      this.windowHeight = window.innerHeight;
    };
  },

};
</script>

<style scoped></style>
